import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import * as _ from 'lodash';
import { HelperService } from './../../../services/helper.service';
import { MemberService } from '../../../rest/api/member.service';
import { AuthService } from '../../../services/auth.service';
import { PaymentService as PaymentLocalService } from '../../../services/payment/payment.service';

@Component({
  selector: 'app-subscription-plan',
  templateUrl: './subscription-plan.component.html',
  styleUrls: ['./subscription-plan.component.scss']
})
export class SubscriptionPlanComponent implements OnInit {
  @Input() currentPlansData;
  accessToken: any;
  packageId: any;
  isCameraPlanEnabled = false;
  plansData: any;
  subscriptionData: any;
  cameraSubscription: any;
  subscriptionPlan: any;
  cameraPlan: any;
  spacePlan: any;
  taxPercentage = 0;

  loader = true;
  constructor(
    private router: Router,
    public paymentLocalService: PaymentLocalService,
    public memberService: MemberService,
    public helperService: HelperService,
    private authService: AuthService) {
    this.accessToken = `Bearer ${this.authService.getAccessToken()}`;
    this.paymentLocalService.planDataSubscription.subscribe(response => {
      if (response) {
        this.plansData = response;
        this.subscriptionPlan  = _.find(this.plansData, {plan_type: 'subscription' }) ? _.find(this.plansData, {plan_type: 'subscription' }) : false;
        if (this.subscriptionPlan && this.subscriptionPlan.tax) {
          this.taxPercentage = this.subscriptionPlan.tax;
        }
        this.cameraPlan  = _.find(this.plansData, {plan_type: 'camera' });
        this.spacePlan  = _.find(this.plansData, {plan_type: 'space' });
        this.loader = false;
      }
    });
  }

  ngOnInit() {
    this.isCameraPlanEnabled = this.memberService.getCurrentSubscription(this.accessToken) ? true : false;
  }

  getCurrentSubscription() {
    this.memberService.getCurrentSubscription(this.accessToken).subscribe(response => {
      this.currentPlansData = this.subscriptionData && this.subscriptionData.plans && this.subscriptionData.plans[0] ? this.subscriptionData.plans : [];
      this.cameraSubscription = _.find(this.currentPlansData, {type: 'camera'});
    });
  }

  submitPlanSteps() {
    this.paymentLocalService.setPackageId(this.packageId);
    if (this.isCameraPlanEnabled) {
      this.paymentLocalService.setCameraPlan('1001');
    } else {
      this.paymentLocalService.setCameraPlan(undefined);
    }
    this.paymentLocalService.submitPlanSteps();
    this.router.navigate(['/subscription/card']);
  }

}
